import React, { PropsWithChildren, createContext, use } from "react";

import { isDefined } from "@utils/helpers";

export type SearchIndexContext = {
    productsIndex: string;
    contentPagesIndex: string;
    querySuggestionsIndex: string;
};

export const SearchIndexContext = createContext<SearchIndexContext | undefined>(
    undefined,
);
SearchIndexContext.displayName = "SearchIndexContext";

export const SearchIndexContextProvider = ({
    children,
    productsIndex,
    contentPagesIndex,
    querySuggestionsIndex,
}: PropsWithChildren<SearchIndexContext>) => (
    <SearchIndexContext
        value={{
            productsIndex: productsIndex,
            contentPagesIndex: contentPagesIndex,
            querySuggestionsIndex: querySuggestionsIndex,
        }}
    >
        {children}
    </SearchIndexContext>
);

export const useSearchIndexContext = (): SearchIndexContext => {
    const context = use<SearchIndexContext | undefined>(
        SearchIndexContext,
    );

    if (!isDefined(context)) {
        throw new Error(`${SearchIndexContext.displayName} is undefined.`);
    }

    return context;
};
